import { useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import useInput from '../../hooks/use-input';
import { resetPassword } from '../../api/authAPI';
import LogoAquamarine from '../../assets/logo_aquamarine.svg?react';

import './ResetPassword.scss';

const PwdStrengthRegex =
	/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{6,}$/;

const ResetPasswd = () => {
	const {
		value: enteredNewPasswd,
		isValid: enteredNewPasswdIsValid,
		hasError: newPasswdInputHasError,
		valueChangeHandler: newPasswdChangedHandler,
		inputBlurHandler: newPasswdBlurHandler,
		reset: resetNewPasswdInput
	} = useInput((value) => PwdStrengthRegex.test(value));

	const {
		value: enteredOldPasswd,
		isValid: enteredOldPasswdIsValid,
		hasError: oldPasswdInputHasError,
		valueChangeHandler: oldPasswdChangedHandler,
		inputBlurHandler: oldPasswdBlurHandler,
		reset: resetOldPasswdInput
	} = useInput((value) => value.trim() !== '');

	const [inputHasError, setInputHasError] = useState('');

	const repeatPasswd = useRef();

	const { userMail } = useParams();

	const navigate = useNavigate();

	const submitResetHandler = (event) => {
		event.preventDefault();
		const enteredRepeatedPasswd =
			repeatPasswd.current.value;

		if (enteredNewPasswd !== enteredRepeatedPasswd) {
			return setInputHasError('Passwords do not match');
		}

		resetPassword(
			userMail,
			enteredOldPasswd,
			enteredNewPasswd
		).then((result) => {
			console.log(result);
			navigate('/login');
		});
		setInputHasError('');
		resetNewPasswdInput();
		resetOldPasswdInput();
		console.log('Submitted');
	};

	let formIsValid = false;

	if (enteredOldPasswdIsValid && enteredNewPasswdIsValid) {
		formIsValid = true;
	}

	const inputClass = newPasswdInputHasError
		? 'form-control is-invalid'
		: 'form-control';

	const oldPasswdClass = oldPasswdInputHasError
		? 'form-control is-invalid'
		: 'form-control';

	return (
		<div className='reset-passwd-container'>
			<div className='reset-passwd-section reset-passwd-brand-wrapper'>
				<div className='reset-passwd-brand-container'>
					<img
						className='login-naur-logo'
						src='/login_logo.svg'
						alt='main-logo'
					/>
					<img
						className='login-doctor-image'
						src='/doctor-img-login.svg'
						alt='doctor-login'
					/>
				</div>
			</div>
			<div className='reset-passwd-section reset-passwd-form-wrapper'>
				<div className='reset-passwd-form-container'>
					<form
						onSubmit={submitResetHandler}
						className='reset-passwd-form'
					>
						<div className='avatar-wrapper'>
							<LogoAquamarine />
						</div>
						<div className='reset-passwd-form-title'>
							<p>Reset your Password</p>
						</div>
						<p className='reset-passwd-form-subtitle'>
							Password must contain an upper-case latter, a
							lower-case latter, special character, a number
							and be 6 or more characteres long
						</p>
						<div className='form-error-message'>
							{inputHasError}
						</div>
						<div className='control-container reset-passwd-input'>
							<label htmlFor='oldPasswd'>
								{' '}
								Old Password
							</label>
							<input
								className={oldPasswdClass}
								id='oldPasswd'
								type='password'
								name='password'
								onChange={oldPasswdChangedHandler}
								onBlur={oldPasswdBlurHandler}
								required
							/>
							<div
								id='validationServerPasswdFeedback'
								class='invalid-feedback'
							>
								Password must contain an upper-case latter,
								a lower-case latter, special character, a
								number and be 6 or more characteres long
							</div>
						</div>
						<div className='control-container reset-passwd-input'>
							<label htmlFor='passwd'> New Password</label>
							<input
								className={inputClass}
								id='password'
								type='password'
								name='password'
								onChange={newPasswdChangedHandler}
								onBlur={newPasswdBlurHandler}
								required
							/>
							<div
								id='validationServerPasswdFeedback'
								class='invalid-feedback'
							>
								Password must contain an upper-case latter,
								a lower-case latter, special character, a
								number and be 6 or more characteres long
							</div>
						</div>
						<div className='control-container reset-passwd-input'>
							<label htmlFor='repeat-passwd'>
								{' '}
								Repeat Password
							</label>
							<input
								className={inputClass}
								id='repeat-passwd'
								type='password'
								name='password'
								ref={repeatPasswd}
								required
							/>
						</div>
						<div className='reset-passwd-form-button'>
							<Button
								className='primary-button'
								type='submit'
								disabled={!formIsValid}
							>
								Reset password
							</Button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default ResetPasswd;
